import { render, staticRenderFns } from "./VueMarquee.vue?vue&type=template&id=5370ad0e&scoped=true&"
import script from "./VueMarquee.vue?vue&type=script&lang=js&"
export * from "./VueMarquee.vue?vue&type=script&lang=js&"
import style0 from "./VueMarquee.vue?vue&type=style&index=0&id=5370ad0e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5370ad0e",
  null
  
)

export default component.exports